import { makeStyles } from '@material-ui/core';

export const useStyle = makeStyles(theme => {
	const {
		breakpoints: { down },
		spacing,
	} = theme;
	return {
		container: {
			width: '100%',
			textAlign: 'center',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
			padding: spacing(10, 4),
			'& > * button': {
				marginTop: spacing(8),
				[down('sm')]: {
					marginTop: spacing(4),
				},
			},
			[down('sm')]: {
				padding: spacing(6, 2, 8, 2),
			},
		},
		sectionTitle: {
			marginBottom: spacing(5),
			[down('sm')]: {
				'& > p': {
					fontSize: '1.8rem',
					padding: 0,
				},
				'& div': {
					width: '50%',
					marginBottom: 0,
				},
			},
		},
		root: {
			background: theme.palette.primary.light,
		},
	};
});
